import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import AppointmentPopup from "./AppointmentPopup";

import "./Newprofile.css";
import MedicalDocumentManager, { MedicalDocumentDraftEditor, uploadDocumentGroups } from "./MedicalDocumentManager";
import { API_BASE } from "../apiConfig";

export default function PatientRegister() {


    const [patientsLoading, setPatientsLoading] = useState(true);

    const today = new Date().toISOString().split("T")[0];

    const initialForm = {
        id: "",
        mr_no: "",
        date: today,
        name: "",
        phone: "",
        age: "",
        sex: "",
        remarks: ""
    };

    const [formData, setFormData] = useState(initialForm);

    const [patients, setPatients] = useState([]);
    const [search, setSearch] = useState("");

    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    const [editId, setEditId] = useState(null);

    const [registrationDocumentGroups, setRegistrationDocumentGroups] = useState([]);

    const [selectedPatient, setSelectedPatient] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const [appointmentPatient, setAppointmentPatient] =
        useState(null);

    const handleAppointment = (patient) => {
        setAppointmentPatient(patient);
    };

    /*
    |--------------------------------------------------------------------------
    | LOAD PATIENTS
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const timer = setTimeout(() => {
            loadPatients(search);
        }, 300);

        return () => clearTimeout(timer);

    }, [search]);


    const loadPatients = async (searchValue = "") => {

        setPatientsLoading(true);

        try {

            const url = `${API_BASE}get.php`;

            console.log("Loading patients from:", url);

            const response = await fetch(url);

            const responseText = await response.text();

            console.log("Patient API raw response:", responseText);

            if (!response.ok) {
                throw new Error(
                    `HTTP Error: ${response.status}`
                );
            }

            let result;

            try {
                result = JSON.parse(responseText);
            } catch (jsonError) {
                console.error(
                    "Invalid patient API JSON:",
                    responseText
                );

                throw new Error(
                    "Patient API did not return valid JSON."
                );
            }

            console.log("Patient API response:", result);

            let patientData = [];

            if (Array.isArray(result)) {

                patientData = result;

            } else if (
                result.data &&
                Array.isArray(result.data)
            ) {

                patientData = result.data;

            }

            /*
            |--------------------------------------------------------------------------
            | LOCAL SEARCH
            |--------------------------------------------------------------------------
            */

            if (searchValue.trim() !== "") {

                const searchText =
                    searchValue.trim().toLowerCase();

                patientData = patientData.filter((patient) => {

                    const mrNo = String(
                        patient.mr_no ||
                        patient.mrNo ||
                        patient.MRNo ||
                        patient.regNo ||
                        ""
                    ).toLowerCase();

                    const name = String(
                        patient.name || ""
                    ).toLowerCase();

                    const phone = String(
                        patient.phone || ""
                    ).toLowerCase();

                    return (
                        mrNo.includes(searchText) ||
                        name.includes(searchText) ||
                        phone.includes(searchText)
                    );

                });

            }

            setPatients(patientData);

        } catch (error) {

            console.error(
                "Patient loading error:",
                error
            );

            setPatients([]);

            Swal.fire({
                icon: "error",
                title: "Unable to load patient list",
                text:
                    error.message ||
                    "Please check the API.",
                didOpen: () => {

                    const container =
                        Swal.getContainer();

                    if (container) {
                        container.style.zIndex = "99999";
                    }

                }
            });

        } finally {

            setPatientsLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | HANDLE CHANGE
    |--------------------------------------------------------------------------
    */

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

    };


    /*
    |--------------------------------------------------------------------------
    | PHONE
    |--------------------------------------------------------------------------
    */

    const handlePhoneChange = (e) => {

        const value =
            e.target.value.replace(/\D/g, "");

        if (value.length <= 10) {

            setFormData((prev) => ({
                ...prev,
                phone: value
            }));

        }

    };


    /*
    |--------------------------------------------------------------------------
    | AGE
    |--------------------------------------------------------------------------
    */

    const handleAgeChange = (e) => {

        const value =
            e.target.value.replace(/\D/g, "");

        if (value.length <= 2) {

            setFormData((prev) => ({
                ...prev,
                age: value
            }));

        }

    };


    /*
    |--------------------------------------------------------------------------
    | VALIDATION
    |--------------------------------------------------------------------------
    */

    const validateForm = () => {

        if (!formData.mr_no.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Required",
                text: "Please enter MR ID No",
                didOpen: () => {
                    Swal.getPopup().style.zIndex = "99999";
                }
            });

            return false;
        }


        if (!formData.date) {

            Swal.fire({
                icon: "warning",
                title: "Required",
                text: "Please select date",
                didOpen: () => {
                    Swal.getPopup().style.zIndex = "99999";
                }
            });

            return false;
        }


        if (!formData.name.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Required",
                text: "Please enter patient name",
                didOpen: () => {
                    Swal.getPopup().style.zIndex = "99999";
                }
            });

            return false;
        }


        if (!formData.phone.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Required",
                text: "Please enter contact number",
                didOpen: () => {
                    Swal.getPopup().style.zIndex = "99999";
                }
            });

            return false;
        }


        if (formData.phone.length !== 10) {

            Swal.fire({
                icon: "warning",
                title: "Invalid Phone",
                text:
                    "Phone number must contain 10 digits",
                didOpen: () => {
                    Swal.getPopup().style.zIndex = "99999";
                }
            });

            return false;
        }


        if (!formData.age) {

            Swal.fire({
                icon: "warning",
                title: "Required",
                text: "Please enter age",
                didOpen: () => {
                    Swal.getPopup().style.zIndex = "99999";
                }
            });

            return false;
        }


        if (
            Number(formData.age) < 1 ||
            Number(formData.age) > 99
        ) {

            Swal.fire({
                icon: "warning",
                title: "Invalid Age",
                text: "Please enter a valid age",
                didOpen: () => {
                    Swal.getPopup().style.zIndex = "99999";
                }
            });

            return false;
        }


        if (!formData.sex) {

            Swal.fire({
                icon: "warning",
                title: "Required",
                text: "Please select gender",
                didOpen: () => {
                    Swal.getPopup().style.zIndex = "99999";
                }
            });

            return false;
        }


        if (!formData.remarks.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Required",
                text: "Please enter patient address",
                didOpen: () => {
                    Swal.getPopup().style.zIndex = "99999";
                }
            });

            return false;
        }


        return true;

    };


    /*
    |--------------------------------------------------------------------------
    | SWEETALERT ABOVE MODAL
    |--------------------------------------------------------------------------
    */

    const showAlert = (options) => {

        Swal.fire({

            ...options,

            didOpen: () => {

                const container =
                    Swal.getContainer();

                const popup =
                    Swal.getPopup();

                if (container) {
                    container.style.zIndex = "99999";
                }

                if (popup) {
                    popup.style.zIndex = "100000";
                }

                if (options.didOpen) {
                    options.didOpen();
                }

            }

        });

    };


    /*
    |--------------------------------------------------------------------------
    | SAVE / UPDATE
    |--------------------------------------------------------------------------
    */

    const handleSave = async () => {

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        setProgress(10);

        try {

            const data = new FormData();

            /*
            |--------------------------------------------------------------------------
            | UPDATE ID
            |--------------------------------------------------------------------------
            */

            if (editId) {
                data.append("id", editId);
            }


            data.append(
                "mr_no",
                formData.mr_no.trim()
            );

            data.append(
                "date",
                formData.date
            );

            data.append(
                "name",
                formData.name.trim()
            );

            data.append(
                "phone",
                formData.phone
            );

            data.append(
                "age",
                formData.age
            );

            data.append(
                "sex",
                formData.sex
            );

            data.append(
                "remarks",
                formData.remarks.trim()
            );


            setProgress(30);


            const api = editId
                ? "update_patient.php"
                : "add_patient.php";


            const response = await fetch(
                `${API_BASE}${api}`,
                editId
                    ? {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            id: Number(editId),
                            mr_no: formData.mr_no.trim(),
                            date: formData.date,
                            name: formData.name.trim(),
                            phone: formData.phone,
                            age: formData.age,
                            sex: formData.sex,
                            remarks: formData.remarks.trim()
                        })
                    }
                    : { method: "POST", body: data }
            );


            setProgress(70);


            const responseText = await response.text();

            let result;

            try {
                result = responseText ? JSON.parse(responseText) : {};
            } catch (jsonError) {
                throw new Error(`Server returned invalid JSON. HTTP ${response.status}`);
            }

            if (!response.ok) {
                throw new Error(
                    result.msg ||
                    result.message ||
                    `HTTP Error: ${response.status}`
                );
            }


            console.log(
                "Save/Update response:",
                result
            );


            setProgress(100);


            /*
            |--------------------------------------------------------------------------
            | DUPLICATE MR ID
            |--------------------------------------------------------------------------
            */

            if (
                result.status === "exists" ||
                result.status === "duplicate"
            ) {

                /*
                IMPORTANT:
                Do NOT close the patient modal here.
                SweetAlert will appear ABOVE the modal.
                */

                showAlert({

                    icon: "info",

                    title: "Duplicate MR ID",

                    html: `
                        <div style="font-size:15px;">
                            MR ID 
                            <strong>
                                ${formData.mr_no}
                            </strong>
                            is already registered.
                            <br/>
                            <small>
                                Please enter a different MR ID.
                            </small>
                        </div>
                    `,

                    confirmButtonText: "OK",

                    confirmButtonColor: "#f39c12"

                });

                return;
            }


            /*
            |--------------------------------------------------------------------------
            | SUCCESS
            |--------------------------------------------------------------------------
            */

            if (
                result.status === "success" ||
                result.status === "updated"
            ) {

                // For a NEW patient, upload the previewed titled document groups only
                // after add_patient.php has returned the new patient ID.
                if (!editId && registrationDocumentGroups.length > 0) {
                    const newPatientId = Number(result.insert_id || result.patient?.id || 0);
                    if (newPatientId > 0) {
                        try {
                            await uploadDocumentGroups(newPatientId, registrationDocumentGroups);
                            setRegistrationDocumentGroups([]);
                        } catch (documentError) {
                            await Swal.fire({
                                icon: "warning",
                                title: "Patient Saved - Document Upload Issue",
                                text: documentError.message || "Patient was registered, but one or more documents could not be uploaded."
                            });
                        }
                    }
                }

                /*
                |--------------------------------------------------------------------------
                | CLOSE POPUP IMMEDIATELY
                |--------------------------------------------------------------------------
                */

                setShowModal(false);

                setSelectedPatient(null);


                /*
                |--------------------------------------------------------------------------
                | RESET EDIT MODE
                |--------------------------------------------------------------------------
                */

                setEditId(null);


                /*
                |--------------------------------------------------------------------------
                | RESET FORM
                |--------------------------------------------------------------------------
                */

                setFormData({

                    ...initialForm,

                    date:
                        new Date()
                            .toISOString()
                            .split("T")[0]

                });


                /*
                |--------------------------------------------------------------------------
                | REFRESH PATIENT LIST
                |--------------------------------------------------------------------------
                */

                await loadPatients(search);


                /*
                |--------------------------------------------------------------------------
                | SUCCESS MESSAGE
                |--------------------------------------------------------------------------
                */

                await Swal.fire({

                    icon: "success",

                    title: "Patient Register",

                    text:
                        result.msg ||
                        "Patient Registered successfully.",

                    timer: 1500,

                    showConfirmButton: false

                });

            } else {

                showAlert({

                    icon: "error",

                    title: "Update Failed",

                    text:
                        result.msg ||
                        "Something went wrong."

                });

            }

        } catch (error) {

            console.error(
                "Save/Update error:",
                error
            );


            showAlert({

                icon: "error",

                title: "Error",

                text:
                    error.message ||
                    "Unable to save patient."

            });

        } finally {

            setTimeout(() => {

                setLoading(false);

                setProgress(0);

            }, 500);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | VIEW PATIENT
    |--------------------------------------------------------------------------
    */

    const handleView = (patient) => {

        setSelectedPatient(patient);

        setShowModal(true);

    };


    /*
    |--------------------------------------------------------------------------
    | EDIT PATIENT INSIDE POPUP
    |--------------------------------------------------------------------------
    */

    const handleEdit = (patient) => {

        setFormData({

            id: patient.id,

            mr_no:
                patient.mr_no ||
                patient.mrNo ||
                patient.MRNo ||
                patient.regNo ||
                "",

            date:
                patient.date
                    ? patient.date.substring(0, 10)
                    : "",

            name:
                patient.name || "",

            phone:
                patient.phone || "",

            age:
                patient.age || "",

            sex:
                patient.sex || "",

            remarks:
                patient.remarks || ""

        });


        setEditId(patient.id);

    };


    /*
    |--------------------------------------------------------------------------
    | DEACTIVATE PATIENT
    |--------------------------------------------------------------------------
    */

    const handleDeactivate = async (patient) => {

        const mrNo =
            patient.mr_no ||
            patient.mrNo ||
            patient.MRNo ||
            patient.regNo ||
            "-";

        const confirm = await Swal.fire({

            title: "Deactivate Patient?",

            html: `
            <div style="font-size:15px;">
                Are you sure you want to deactivate
                <br/>
                <strong>${patient.name || "-"}</strong>
                <br/>
                <small>
                    MR ID: ${mrNo}
                </small>
            </div>
        `,

            icon: "warning",

            showCancelButton: true,

            confirmButtonText: "Yes, Deactivate",

            cancelButtonText: "Cancel",

            confirmButtonColor: "#dc3545",

            cancelButtonColor: "#6c757d",

            reverseButtons: true

        });


        if (!confirm.isConfirmed) {
            return;
        }


        try {

            setLoading(true);


            const patientId = Number(
                patient.id ||
                patient.patient_id ||
                0
            );

            if (!patientId) {
                throw new Error("Patient ID is missing.");
            }

            console.log(
                "Deactivating patient ID:",
                patientId
            );

            const response = await fetch(
                `${API_BASE}deactivate_patient.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        patient_id: patientId
                    })
                }
            );


            /*
            |--------------------------------------------------------------------------
            | READ RAW RESPONSE FIRST
            |--------------------------------------------------------------------------
            */

            const responseText =
                await response.text();


            console.log(
                "Deactivate API raw response:",
                responseText
            );


            if (!response.ok) {

                throw new Error(
                    `HTTP ${response.status}: ${responseText}`
                );

            }


            let result;

            try {

                result =
                    JSON.parse(responseText);

            } catch (jsonError) {

                console.error(
                    "Invalid deactivate JSON:",
                    responseText
                );

                throw new Error(
                    "Deactivate API did not return valid JSON."
                );

            }


            console.log(
                "Deactivate API response:",
                result
            );


            /*
            |--------------------------------------------------------------------------
            | SUCCESS
            |--------------------------------------------------------------------------
            */

            if (
                result.status === "success" ||
                result.status === "updated" ||
                result.success === true
            ) {

                await Swal.fire({

                    icon: "success",

                    title: "Patient Deactivated",

                    text:
                        result.msg ||
                        result.message ||
                        "Patient has been deactivated successfully.",

                    timer: 1500,

                    showConfirmButton: false

                });


                /*
                |--------------------------------------------------------------------------
                | REFRESH LIST
                |--------------------------------------------------------------------------
                */

                await loadPatients(search);

            } else {

                /*
                |--------------------------------------------------------------------------
                | SHOW ACTUAL PHP MESSAGE
                |--------------------------------------------------------------------------
                */

                showAlert({

                    icon: "info",

                    title: "Unable to deactivate patient",

                    text:
                        result.msg ||
                        result.message ||
                        "The server could not deactivate this patient."

                });

            }

        } catch (error) {

            console.error(
                "Deactivate error:",
                error
            );


            showAlert({

                icon: "Info",

                title: "Deactivation",

                html: `
                <div style="font-size:14px;text-align:left;">
                    <strong>Unable to deactivate patient.</strong>
                    <br/><br/>
                    ${error.message || "Unknown error"}
                </div>
            `

            });

        } finally {

            setLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | CANCEL FORM
    |--------------------------------------------------------------------------
    */

    const handleCancel = () => {

        setFormData({

            ...initialForm,

            date:
                new Date()
                    .toISOString()
                    .split("T")[0]

        });

        setEditId(null);

    };


    /*
    |--------------------------------------------------------------------------
    | CLOSE MODAL
    |--------------------------------------------------------------------------
    */

    const closeModal = () => {

        setShowModal(false);

        setSelectedPatient(null);

        setEditId(null);

    };


    return (

        <div className="container-fluid patient-manager">

            <div className="row" style={{ height: '85vh', overflow: 'auto', marginTop: '50px', paddingBottom: '150px' }}>

                {/* =========================================================
                    LEFT FORM
                ========================================================= */}

                <div className="col-md-5">

                    <div className="patient-form-card">

                        <div className="card-heading">

                            <div className="heading-icon">

                                <i className="fa fa-user"></i>

                            </div>

                            <div>

                                <h3>

                                    {editId
                                        ? "Edit Patient"
                                        : "New Patient"}

                                </h3>

                                <p>

                                    {editId
                                        ? "Update patient information"
                                        : "Enter patient information"}

                                </p>

                            </div>

                        </div>


                        <div className="form-grid">

                            {/* MR ID */}

                            <div className="form-field">

                                <label>

                                    MR ID No{" "}

                                    <span className="required">
                                        *
                                    </span>

                                </label>

                                <div className="input-wrapper">

                                    <i className="fa fa-id-card"></i>

                                    <input
                                        name="mr_no"
                                        type="text"
                                        placeholder="Enter MR ID No"
                                        value={formData.mr_no}
                                        onChange={handleChange}
                                    />

                                </div>

                            </div>


                            {/* DATE */}

                            <div className="form-field">

                                <label>

                                    Date{" "}

                                    <span className="required">
                                        *
                                    </span>

                                </label>

                                <div className="input-wrapper">

                                    <i className="fa fa-calendar"></i>

                                    <input
                                        name="date"
                                        type="date"
                                        value={formData.date}
                                        onChange={handleChange}
                                    />

                                </div>

                            </div>


                            {/* NAME */}

                            <div className="form-field full">

                                <label>

                                    Patient Name{" "}

                                    <span className="required">
                                        *
                                    </span>

                                </label>

                                <div className="input-wrapper">

                                    <i className="fa fa-user"></i>

                                    <input
                                        name="name"
                                        type="text"
                                        placeholder="Enter patient name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />

                                </div>

                            </div>


                            {/* PHONE */}

                            <div className="form-field">

                                <label>

                                    Contact Number{" "}

                                    <span className="required">
                                        *
                                    </span>

                                </label>

                                <div className="input-wrapper">

                                    <i className="fa fa-phone"></i>

                                    <input
                                        name="phone"
                                        type="text"
                                        placeholder="Contact number"
                                        value={formData.phone}
                                        maxLength={10}
                                        onChange={handlePhoneChange}
                                    />

                                </div>

                            </div>


                            {/* AGE */}

                            <div className="form-field">

                                <label>

                                    Age{" "}

                                    <span className="required">
                                        *
                                    </span>

                                </label>

                                <div className="input-wrapper">

                                    <i className="fa fa-calendar"></i>

                                    <input
                                        name="age"
                                        type="text"
                                        placeholder="Age"
                                        value={formData.age}
                                        maxLength={2}
                                        onChange={handleAgeChange}
                                    />

                                </div>

                            </div>


                            {/* GENDER */}

                            <div className="form-field full">

                                <label>

                                    Gender{" "}

                                    <span className="required">
                                        *
                                    </span>

                                </label>

                                <div className="gender-options">

                                    {[
                                        "Male",
                                        "Female"
                                    ].map((s) => (

                                        <label
                                            key={s} style={{ display: 'flex', height: '100px !important', width: '100%' }}
                                            className={
                                                `gender-option ${formData.sex === s
                                                    ? "selected"
                                                    : ""
                                                }`
                                            }
                                        >

                                            <input
                                                type="radio"
                                                name="sex"
                                                value={s}
                                                checked={
                                                    formData.sex === s
                                                }
                                                onChange={handleChange}
                                            />

                                            <i
                                                className={
                                                    s === "Male"
                                                        ? "fa fa-male"
                                                        : "fa fa-female"
                                                }
                                            ></i>

                                            <span>
                                                {s}
                                            </span>

                                        </label>

                                    ))}

                                </div>

                            </div>


                            {/* ADDRESS */}

                            <div className="form-field full">

                                <label>

                                    Address{" "}

                                    <span className="required">
                                        *
                                    </span>

                                </label>

                                <div className="input-wrapper textarea-wrapper">

                                    <i className="fa fa-map-marker"></i>

                                    <textarea
                                        name="remarks"
                                        placeholder="Enter patient address"
                                        value={formData.remarks}
                                        onChange={handleChange}
                                    />

                                </div>

                            </div>

                        </div>


                        {!editId && (
                            <MedicalDocumentDraftEditor
                                groups={registrationDocumentGroups}
                                onChange={setRegistrationDocumentGroups}
                                disabled={loading}
                                heading="Documents / Reports"
                            />
                        )}

                        {/* PROGRESS */}

                        {loading && (

                            <div className="saving-container">

                                <div className="progress-track">

                                    <div
                                        className="progress-bar"
                                        style={{
                                            width:
                                                `${progress}%`
                                        }}
                                    />

                                </div>

                                <span>

                                    Saving {progress}%

                                </span>

                            </div>

                        )}


                        {/* BUTTONS */}

                        <div className="form-actions">

                            <button
                                type="button"
                                className="btn-register"
                                onClick={handleSave}
                                disabled={loading}
                            >

                                <i className="fa fa-check"></i> &nbsp;

                                {loading
                                    ? "Processing..."
                                    : editId
                                        ? "Update Patient"
                                        : "Register Patient"}

                            </button>


                            <button
                                type="button"
                                className="btn-cancel"
                                onClick={handleCancel}
                                disabled={loading}
                            >

                                Cancel

                            </button>

                        </div>

                    </div>

                </div>


                {/* =========================================================
                    RIGHT PATIENT LIST
                ========================================================= */}

                <div className="col-md-7">

                    <div className="patients-card">

                        <div className="patients-header">

                            <div>

                                <h3>

                                    <i className="fa fa-users"></i>

                                    &nbsp;  Search Patient

                                </h3>

                                <p>

                                    Search and manage registered patients

                                </p>

                            </div>


                            <div className="patient-count">

                                {patients.length}

                            </div>

                        </div>


                        {/* SEARCH */}

                        <div className="patient-search">

                            <i className="fa fa-search"></i>

                            <input
                                type="text"
                                placeholder="Search by MR ID, patient name or phone number..."
                                value={search}
                                onChange={(e) =>
                                    setSearch(e.target.value)
                                }
                            />


                            {/* {search && (

                                <button
                                    type="button"
                                    onClick={() =>
                                        setSearch("")
                                    }
                                >

                                    <i className="fa fa-times"></i>

                                </button>

                            )} */}

                        </div>


                        {/* TABLE */}

                        <div className="table-responsive" style={{ padding: '25px',height:'60vh',overflow:'auto' }}>

                            <table className="table patient-table">

                                <thead>

                                    <tr>

                                        <th>
                                            Sl No.
                                        </th>

                                        <th>
                                            MR ID
                                        </th>

                                        <th>
                                            Patient Name
                                        </th>

                                        <th>
                                            Phone Number
                                        </th>

                                        <th>
                                            Actions
                                        </th>

                                    </tr>

                                </thead>


                                <tbody>

                                    {patientsLoading ? (

                                        <tr>

                                            <td
                                                colSpan="5"
                                                className="patient-loading"
                                            >

                                                <div className="patient-loader">

                                                    <div className="spinner-border text-primary"></div>

                                                    <span>
                                                        Loading patients...
                                                    </span>

                                                </div>

                                            </td>

                                        </tr>

                                    ) : patients.length === 0 ? (

                                        <tr>

                                            <td
                                                colSpan="5"
                                                className="empty-patient"
                                            >



                                                <div>
                                                    <i className="fa fa-users"></i> &nbsp; No patients found
                                                </div>

                                            </td>

                                        </tr>

                                    ) : (

                                        patients.map(
                                            (patient, index) => (

                                                <tr key={patient.id}>

                                                    <td>
                                                        {index + 1}
                                                    </td>

                                                    <td>

                                                        <span className="mr-badge">

                                                            {patient.mr_no ||
                                                                patient.mrNo ||
                                                                patient.MRNo ||
                                                                patient.regNo ||
                                                                "-"}

                                                        </span>

                                                    </td>

                                                    <td>

                                                        <div className="patient-name">

                                                            <div className="patient-avatar">

                                                                <i className="fa fa-user"></i>

                                                            </div>

                                                            <span>
                                                                {patient.name}
                                                            </span>

                                                        </div>

                                                    </td>

                                                    <td>
                                                        {patient.phone}
                                                    </td>

                                                    <td>

                                                        <div
                                                            className="patient-actions"
                                                            style={{
                                                                display: "flex",
                                                                gap: "8px",
                                                                alignItems: "center"
                                                            }}
                                                        >

                                                            <button
                                                                type="button"
                                                                className="btn-view"
                                                                title="View Patient"
                                                                onClick={() =>
                                                                    handleView(patient)
                                                                }
                                                            >

                                                                <i className="fa fa-eye"></i>

                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="btn-appointment"
                                                                title="Create Appointment"
                                                                onClick={() =>
                                                                    handleAppointment(patient)
                                                                }
                                                            >
                                                                <i className="fa fa-stethoscope"></i>
                                                            </button>


                                                            <button
                                                                type="button"
                                                                className="btn-deactivate-list"
                                                                title="Deactivate Patient"
                                                                onClick={() =>
                                                                    handleDeactivate(patient)
                                                                }
                                                                disabled={patientsLoading}
                                                            >

                                                                <i className="fa fa-ban"></i>

                                                            </button>

                                                        </div>

                                                    </td>

                                                </tr>

                                            )
                                        )

                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

            </div>


            {/* =============================================================
                PATIENT DETAILS / EDIT POPUP
            ============================================================= */}

            {showModal && selectedPatient && (

                <div
                    className="patient-modal-overlay"
                    onClick={closeModal}
                >

                    <div
                        className="patient-modal"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        {/* HEADER */}

                        <div className="patient-modal-header">

                            <div className="modal-patient-heading">

                                <div className="modal-patient-avatar">

                                    <i className="fa fa-user"></i>

                                </div>


                                <div>

                                    <h3 style={{ color: 'white' }}>

                                        {editId
                                            ? "Edit Patient"
                                            : "Patient Details"}

                                    </h3>

                                    <span>

                                        MR ID:{" "}

                                        {formData.mr_no ||
                                            selectedPatient.mr_no ||
                                            selectedPatient.mrNo ||
                                            selectedPatient.MRNo ||
                                            selectedPatient.regNo ||
                                            "-"}

                                    </span>

                                </div>

                            </div>


                            <button
                                type="button"
                                className="modal-close"
                                onClick={closeModal}
                            >

                                <i className="fa fa-times"></i>

                            </button>

                        </div>


                        {/* BODY */}

                        <div className="patient-modal-body">

                            {editId ? (

                                /*
                                =====================================================
                                EDIT MODE
                                =====================================================
                                */

                                <div className="form-grid">

                                    {/* MR ID */}

                                    <div className="form-field">

                                        <label>
                                            MR ID No
                                            <span className="required">
                                                *
                                            </span>
                                        </label>

                                        <div className="input-wrapper">

                                            <i className="fa fa-id-card"></i>

                                            <input
                                                name="mr_no"
                                                type="text"
                                                value={formData.mr_no}
                                                onChange={handleChange}
                                            />

                                        </div>

                                    </div>


                                    {/* DATE */}

                                    <div className="form-field">

                                        <label>
                                            Registration Date
                                            <span className="required">
                                                *
                                            </span>
                                        </label>

                                        <div className="input-wrapper">

                                            <i className="fa fa-calendar"></i>

                                            <input
                                                name="date"
                                                type="date"
                                                value={formData.date}
                                                onChange={handleChange}
                                            />

                                        </div>

                                    </div>


                                    {/* NAME */}

                                    <div className="form-field full">

                                        <label>
                                            Patient Name
                                            <span className="required">
                                                *
                                            </span>
                                        </label>

                                        <div className="input-wrapper">

                                            <i className="fa fa-user"></i>

                                            <input
                                                name="name"
                                                type="text"
                                                value={formData.name}
                                                onChange={handleChange}
                                            />

                                        </div>

                                    </div>


                                    {/* PHONE */}

                                    <div className="form-field">

                                        <label>
                                            Contact Number
                                            <span className="required">
                                                *
                                            </span>
                                        </label>

                                        <div className="input-wrapper">

                                            <i className="fa fa-phone"></i>

                                            <input
                                                name="phone"
                                                type="text"
                                                value={formData.phone}
                                                maxLength={10}
                                                onChange={handlePhoneChange}
                                            />

                                        </div>

                                    </div>


                                    {/* AGE */}

                                    <div className="form-field">

                                        <label>
                                            Age
                                            <span className="required">
                                                *
                                            </span>
                                        </label>

                                        <div className="input-wrapper">

                                            <i className="fa fa-birthday-cake"></i>

                                            <input
                                                name="age"
                                                type="text"
                                                value={formData.age}
                                                maxLength={2}
                                                onChange={handleAgeChange}
                                            />

                                        </div>

                                    </div>


                                    {/* GENDER */}

                                    <div className="form-field full">

                                        <label>
                                            Gender
                                            <span className="required">
                                                *
                                            </span>
                                        </label>

                                        <div className="gender-options">

                                            {[
                                                "Male",
                                                "Female"
                                            ].map((s) => (

                                                <label
                                                    key={s} style={{ display: 'flex', height: '100px !important', width: '100%' }}
                                                    className={
                                                        `gender-option ${formData.sex === s
                                                            ? "selected"
                                                            : ""
                                                        }`
                                                    }
                                                >

                                                    <input
                                                        type="radio"
                                                        name="sex"
                                                        value={s}
                                                        checked={
                                                            formData.sex === s
                                                        }
                                                        onChange={handleChange}
                                                    />

                                                    <i
                                                        className={
                                                            s === "Male"
                                                                ? "fa fa-male"
                                                                : "fa fa-female"
                                                        }
                                                    ></i>

                                                    <span>
                                                        {s}
                                                    </span>

                                                </label>

                                            ))}

                                        </div>

                                    </div>


                                    {/* ADDRESS */}

                                    <div className="form-field full">

                                        <label>
                                            Address
                                            <span className="required">
                                                *
                                            </span>
                                        </label>

                                        <div className="input-wrapper textarea-wrapper">

                                            <i className="fa fa-map-marker"></i>

                                            <textarea
                                                name="remarks"
                                                value={formData.remarks}
                                                onChange={handleChange}
                                            />

                                        </div>

                                    </div>

                                </div>

                            ) : (

                                /*
                                =====================================================
                                VIEW MODE
                                =====================================================
                                */

                                <div className="patient-detail-grid">

                                    {/* MR ID */}

                                    <div className="detail-item">

                                        <label>
                                            MR ID No
                                        </label>

                                        <div>

                                            <i className="fa fa-id-card"></i>

                                            {selectedPatient.mr_no ||
                                                selectedPatient.mrNo ||
                                                selectedPatient.MRNo ||
                                                selectedPatient.regNo ||
                                                "-"}

                                        </div>

                                    </div>


                                    {/* DATE */}

                                    <div className="detail-item">

                                        <label>
                                            Registration Date
                                        </label>

                                        <div>

                                            <i className="fa fa-calendar"></i>

                                            {selectedPatient.date
                                                ? selectedPatient.date.substring(
                                                    0,
                                                    10
                                                )
                                                : "-"}

                                        </div>

                                    </div>


                                    {/* NAME */}

                                    <div className="detail-item full">

                                        <label>
                                            Patient Name
                                        </label>

                                        <div>

                                            <i className="fa fa-user"></i>

                                            {selectedPatient.name ||
                                                "-"}

                                        </div>

                                    </div>


                                    {/* PHONE */}

                                    <div className="detail-item">

                                        <label>
                                            Contact Number
                                        </label>

                                        <div>

                                            <i className="fa fa-phone"></i>

                                            {selectedPatient.phone ||
                                                "-"}

                                        </div>

                                    </div>


                                    {/* AGE */}

                                    <div className="detail-item">

                                        <label>
                                            Age
                                        </label>

                                        <div>

                                            <i className="fa fa-birthday-cake"></i>

                                            {selectedPatient.age
                                                ? `${selectedPatient.age} Years`
                                                : "-"}

                                        </div>

                                    </div>


                                    {/* GENDER */}

                                    <div className="detail-item">

                                        <label>
                                            Gender
                                        </label>

                                        <div>

                                            <i
                                                className={
                                                    selectedPatient.sex ===
                                                        "Male"
                                                        ? "fa fa-male"
                                                        : "fa fa-female"
                                                }
                                            ></i>

                                            {selectedPatient.sex ||
                                                "-"}

                                        </div>

                                    </div>


                                    {/* ADDRESS */}

                                    <div className="detail-item full">

                                        <label>
                                            Address
                                        </label>

                                        <div className="address-detail">

                                            <i className="fa fa-map-marker"></i>

                                            <span>

                                                {selectedPatient.remarks ||
                                                    "-"}

                                            </span>

                                        </div>

                                    </div>

                                </div>

                            )}

                            <MedicalDocumentManager
                                patientId={selectedPatient.id}
                                heading="Documents / Reports"
                            />

                        </div>


                        {/* FOOTER */}

                        <div className="patient-modal-footer">

                            {editId ? (

                                /*
                                =====================================================
                                EDIT FOOTER
                                =====================================================
                                */

                                <>

                                    <button
                                        type="button"
                                        className="btn-modal-edit"
                                        onClick={handleSave}
                                        disabled={loading}
                                    >

                                        <i className="fa fa-save"></i>

                                        {loading
                                            ? "Saving..."
                                            : "Save Changes"}

                                    </button>


                                    <button
                                        type="button"
                                        className="btn-modal-close"
                                        onClick={() => {

                                            /*
                                            Return to VIEW mode
                                            */

                                            setEditId(null);

                                            setFormData({

                                                ...initialForm,

                                                date:
                                                    new Date()
                                                        .toISOString()
                                                        .split("T")[0]

                                            });

                                        }}
                                        disabled={loading}
                                    >

                                        Cancel

                                    </button>

                                </>

                            ) : (

                                /*
                                =====================================================
                                VIEW FOOTER
                                =====================================================
                                */

                                <>

                                    <button
                                        type="button"
                                        className="btn-modal-edit"
                                        onClick={() =>
                                            handleEdit(
                                                selectedPatient
                                            )
                                        }
                                    >

                                        <i className="fa fa-edit"></i>

                                        Edit Patient

                                    </button>


                                    <button
                                        type="button"
                                        className="btn-modal-close"
                                        onClick={closeModal}
                                    >

                                        Close

                                    </button>

                                </>

                            )}

                        </div>

                    </div>

                </div>

            )}

            {appointmentPatient && (

                <AppointmentPopup
                    patient={appointmentPatient}

                    onClose={() =>
                        setAppointmentPatient(null)
                    }

                    onSuccess={() => {
                        loadPatients(search);
                    }}
                />

            )}

        </div>

    );

}